'use client'

import { useServicePageEngagement } from '@/lib/analytics-hooks'

/**
 * Renders nothing; mounts the service_page_engagement rule (45s visible +
 * 50% scroll, once per page view) for the route subtree it is placed in.
 */
export default function ServicePageEngagementTracker() {
  useServicePageEngagement()
  return null
}
